"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ellipseString;

function ellipseString(string, maxLength) {
  return string.substring(0, maxLength).trim().replace(/(,|;|\.|\?|!)\s*$/, '') + '…';
}